import {useTranslation} from "react-i18next";

export default function Slogan(props){
  const {t} = useTranslation();
  return (
    <div className={`${props.className} flex justify-center w-full`}>
      <div className={`py-8 lg:py-10 px-mobile lg:px-0 w-full lg:w-[1200px]`}>
          <h1 className="mb-2 text-3xl font-light lg:text-5xl text-dark-navy">
            {t('home.slogan.title-1')}
            <span className="ml-2 font-medium">{t('home.slogan.title-2')}</span>
          </h1>
          <h3 className="-mb-1.5 text-base lg:text-2xl text-dark-navy">{t('home.slogan.comment-1')}</h3>
          <h3 className="text-base lg:text-2xl text-dark-navy">{t('home.slogan.comment-2')}</h3>
      </div>
    </div>
  );
}